var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
var _c, _d, _e, _f, _g, _h;
import { createMuiTheme } from '@material-ui/core/styles';
import React from 'react';
import { ArrowRight } from '@abdt/icons';
import { typography } from '@abdt/design-tokens';
import base from './base';
var tokens = createMuiTheme(base, {
    colors: {
        primary: {
            10: '#F7F9FF',
            20: '#E1EAFF',
            100: '#5780EA',
        },
        secondary: {
            80: '#333B51',
        },
    },
    palette: {
        primary: {
            light: '#7294ea',
            main: '#5780EA',
            contrastText: '#fff',
        },
        secondary: {
            light: '#7294ea',
            main: '#5780EA',
            contrastText: '#fff',
        },
        text: {
            primary: '#333B51',
            secondary: '#999DA8',
        },
        divider: '#E6E7EA',
    },
    typography: {
        body1: __assign({}, typography.text.l),
        body2: __assign({}, typography.text.m),
        button: __assign({}, typography.text.m),
    },
});
var theme = createMuiTheme(tokens, {
    Message: {
        info: {
            '& $infoIcon': {
                color: tokens.palette.primary.main,
            },
            '& $indicator': {
                backgroundColor: tokens.palette.primary.main,
            },
        },
        infoIcon: {},
        indicator: {},
    },
    props: {
        MuiBreadcrumbs: {
            separator: React.createElement(ArrowRight, {
                color: '#9599a4',
                width: 16,
                height: 16,
            }),
        },
        MuiTextField: {
            size: 'small',
        },
        Message: {
            variant: 'default',
        },
    },
    overrides: {
        // Tab
        MuiTab: {
            root: {
                fontSize: 14,
                lineHeight: '20px',
            },
        },
        // Tooltip
        MuiTooltip: {
            tooltip: {
                backgroundColor: '#fff',
                filter: 'drop-shadow(0px 8px 32px rgba(0, 0, 0, 0.08))',
                color: tokens.palette.text.primary,
            },
            arrow: {
                color: '#fff',
            },
        },
        // IconButton
        MuiIconButton: {
            root: {
                '&.Mui-focusVisible': {
                    boxShadow: "0 0 0 2px " + tokens.palette.primary.main,
                },
            },
        },
        // Container
        MuiContainer: {
            root: {
                minWidth: 824,
            },
        },
        // Accordion
        MuiAccordion: {
            root: {
                boxShadow: 'none',
                '&:before': {
                    display: 'none',
                },
                '&$expanded': {
                    margin: 'auto',
                },
                '&$disabled': {
                    backgroundColor: 'transparent',
                },
            },
            expanded: {},
        },
        MuiAccordionSummary: {
            root: {
                marginBottom: -1,
                minHeight: 'initial',
                '&$expanded': {
                    minHeight: 'initial',
                },
                '&$focused': {
                    backgroundColor: (_c = tokens.colors) === null || _c === void 0 ? void 0 : _c.primary[20],
                },
            },
            content: {
                margin: 0,
                '&$expanded': {
                    margin: 0,
                },
            },
            expanded: {},
        },
        MuiOutlinedInput: {
            root: {
                '&$focused $notchedOutline': {
                    borderColor: tokens.palette.primary.main,
                },
            },
        },
        // Typography
        MuiTypography: {
            body1: (_a = {},
                _a[tokens.breakpoints.down('sm')] = __assign({}, typography.text.l),
                _a),
            body2: (_b = {},
                _b[tokens.breakpoints.down('sm')] = __assign({}, typography.text.m),
                _b),
            colorPrimary: {
                color: tokens.palette.text.primary,
            },
            colorSecondary: {
                color: tokens.palette.text.secondary,
            },
        },
        // Link
        MuiLink: {
            root: {
                color: tokens.palette.primary.main,
                cursor: 'pointer',
                '&:hover': {
                    color: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    color: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
        },
        // Checkbox
        MuiCheckbox: {
            root: {
                '&.Mui-focusVisible': {
                    '& .CheckBoxIcon': {
                        '&:after': {
                            boxShadow: "inset 0px 0px 0px 2px " + ((_d = tokens.colors) === null || _d === void 0 ? void 0 : _d.primary[20]),
                        },
                    },
                },
            },
        },
        // Radio
        MuiRadio: {
            root: {
                '&.Mui-focusVisible': {
                    '& .RadioIcon': {
                        '&:before': {
                            boxShadow: "inset 0px 0px 0px 2px " + ((_e = tokens.colors) === null || _e === void 0 ? void 0 : _e.primary[20]),
                        },
                    },
                },
            },
        },
        // Pagination
        MuiPaginationItem: {
            page: {
                '&$selected': {
                    '&:hover': {
                        backgroundColor: (_f = tokens.colors) === null || _f === void 0 ? void 0 : _f.primary[20],
                    },
                    '&:active': {
                        backgroundColor: (_g = tokens.colors) === null || _g === void 0 ? void 0 : _g.primary[20],
                    },
                },
            },
        },
        // Button
        MuiButton: {
            root: {
                '&.Mui-focusVisible': {
                    boxShadow: "0 0 0 2px " + ((_h = tokens.colors) === null || _h === void 0 ? void 0 : _h.primary[20]) + " !important",
                },
            },
            text: {
                color: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: '#ffffff',
                },
                '&:active': {
                    backgroundColor: '#ffffff',
                },
            },
            textPrimary: {
                color: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: '#ffffff',
                },
                '&:active': {
                    backgroundColor: '#ffffff',
                },
            },
            contained: {
                color: '#ffffff',
                backgroundColor: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
            containedPrimary: {
                color: '#ffffff',
                backgroundColor: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
            containedSecondary: {
                color: '#ffffff',
                backgroundColor: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
            outlined: {
                color: tokens.palette.primary.main,
                border: "1px solid " + tokens.palette.primary.main,
                '&:hover': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&:active': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&.Mui-disabled': {
                    border: 'none',
                },
            },
            outlinedPrimary: {
                color: tokens.palette.primary.main,
                border: "1px solid " + tokens.palette.primary.main,
                '&:hover': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&:active': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&.Mui-disabled': {
                    border: 'none',
                },
            },
        },
        // @ts-ignore
        // Calendar
        MuiPickersPopper: {
            root: {
                '&[x-placement="bottom"]': {
                    '& $paper': {
                        '&::before': {
                            borderBottom: "13px solid " + tokens.palette.secondary.main,
                        },
                    },
                },
            },
        },
        MuiPickersBasePicker: {
            pickerView: {
                backgroundColor: tokens.palette.secondary.main,
            },
        },
        MuiPickersDesktopDateRangeCalendar: {
            rangeCalendarContainer: {
                backgroundColor: tokens.palette.secondary.main,
            },
            arrowSwitcher: {
                '& [class*="MuiTypography-root"]': {
                    color: '#fff',
                },
            },
        },
        MuiPickersFadeTransition: {
            root: {
                '& > *': {
                    color: tokens.palette.primary.contrastText,
                },
            },
        },
        MuiPickersCalendarHeader: {
            monthText: {
                color: tokens.palette.primary.contrastText,
            },
            yearSelectionSwitcher: {
                color: tokens.palette.primary.contrastText,
            },
        },
        MuiPickersDateRangeDay: {
            rangeIntervalDayHighlight: {
                backgroundColor: 'rgba(0, 178, 169, 0.05)',
            },
            dayInsideRangeInterval: {
                color: tokens.palette.secondary.main,
            },
            dayOutsideRangeInterval: {
                '&:hover': {
                    border: 'none',
                },
            },
        },
        MuiPickersDay: {
            root: {
                color: tokens.palette.text.primary,
                '&$selected': {
                    backgroundColor: tokens.palette.primary.main,
                    '&:hover, &:active, &:focus': {
                        backgroundColor: tokens.palette.primary.main,
                    },
                },
                '&:focus.Mui-selected[class*="MuiButtonBase-root"]': {
                    backgroundColor: tokens.palette.primary.main,
                },
            },
            today: {
                color: tokens.palette.primary.main,
            },
        },
        MuiPickersYear: {
            yearButton: {
                color: tokens.palette.primary.contrastText,
            },
        },
        MuiPickersArrowSwitcher: {
            root: {
                '& button > span > svg': {
                    color: tokens.palette.primary.contrastText,
                },
                '& h6': {
                    color: tokens.palette.primary.contrastText,
                },
            },
        },
        MuiTextField: {
            root: {
                '& label': {
                    width: 'calc(100% - 16px)',
                    paddingRight: 40,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
            },
        },
    },
    // File
    File: {
        name: {
            marginTop: 2,
        },
    },
});
export default theme;
//# sourceMappingURL=ecp.js.map